import './chunk-6ea13200.js';
import './helpers.js';
import './chunk-17222463.js';
import { I as Icon } from './chunk-d732d84c.js';
export { I as BIcon } from './chunk-d732d84c.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Icon);
  }
};
use(Plugin);

export default Plugin;
